"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require("react-router-dom");

var _Apply = require("./Apply");

var _Apply2 = _interopRequireDefault(_Apply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this page renders the vacatureItem in the VacatureList

var VacatureItem = function VacatureItem(props) {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isApplying = _useState2[0],
      setIsApplying = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  //toggle's the apply modal


  var applyHandler = function applyHandler(e) {
    e.preventDefault();
    if (isApplying === false) {
      setIsApplying(true);
      setIsLoading(true);
    } else {
      setIsApplying(false);
    }
  };

  var closeModal = function closeModal() {
    setIsApplying(false);
  };

  //prepares the first 110 letters of the full text property
  var text = [];
  var reduceText = function reduceText() {
    text.push(props.text.slice(0, 112));
  };
  reduceText();
  return _react2.default.createElement(
    _react.Fragment,
    null,
    _react2.default.createElement(
      "div",
      { className: "card" },
      _react2.default.createElement(
        "div",
        { className: "card-image__container" },
        _react2.default.createElement("img", { src: props.image })
      ),
      _react2.default.createElement(
        "div",
        { className: "card-text" },
        props.pdf === true && _react2.default.createElement(
          _reactRouterDom.Link,
          { className: "card__title", to: "/vacature/" + props.id },
          props.title
        ),
        props.pdf === false && _react2.default.createElement(
          "a",
          { className: "card__title", onClick: applyHandler },
          props.title
        ),
        isApplying === true && _react2.default.createElement(_Apply2.default, {
          color: props.color,
          vacature: props,
          closeThisModal: setIsApplying
        }),
        _react2.default.createElement(
          "div",
          { className: "card__text" },
          props.pdf && _react2.default.createElement(
            _reactRouterDom.Link,
            { to: "/vacature/" + props.id },
            text,
            " ",
            _react2.default.createElement(
              "p",
              { className: "card__link" },
              " ",
              " solliciteer nu ->",
              " "
            )
          ),
          props.pdf === false && _react2.default.createElement(
            _react.Fragment,
            null,
            text,
            " ",
            _react2.default.createElement(
              "a",
              { className: "card__link", onClick: applyHandler },
              " ",
              " solliciteer nu ->",
              " "
            )
          ),
          isApplying === true && _react2.default.createElement(_Apply2.default, {
            color: props.color,
            vacature: props,
            closeThisModal: closeModal
          })
        )
      )
    )
  );
};

exports.default = VacatureItem;